import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className"];
import React, { forwardRef, memo } from 'react';
import { Button } from '@deliveryhero/armor';
import { useDatePickerActionBarClassNames } from './hooks/useDatePickerActionBarClassNames';
import { useDatePickerActionBar } from './hooks/useDatePickerActionBar';
import { DatePickerActionBarRoot, DatePickerActionBarActions } from './style';
import { DATE_PICKER_ACTION_BAR_CLASS_PREFIX } from './constants';
/**
 * @internal
 */
export var DatePickerActionBar = memo(forwardRef(function DatePickerActionBar(_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var classNameComponents = useDatePickerActionBarClassNames(DATE_PICKER_ACTION_BAR_CLASS_PREFIX, className);
  var _useDatePickerActionB = useDatePickerActionBar(props, ref),
    rootProps = _useDatePickerActionB.rootProps,
    showBar = _useDatePickerActionB.showBar,
    getApplyButtonProps = _useDatePickerActionB.getApplyButtonProps,
    showApplyButton = _useDatePickerActionB.showApplyButton,
    showClearSelectionButton = _useDatePickerActionB.showClearSelectionButton,
    showTodayButtonRegular = _useDatePickerActionB.showTodayButtonRegular,
    showTodayButtonWide = _useDatePickerActionB.showTodayButtonWide,
    getClearSelectionButtonProps = _useDatePickerActionB.getClearSelectionButtonProps,
    getTodayButtonProps = _useDatePickerActionB.getTodayButtonProps;
  return React.createElement(DatePickerActionBarRoot, Object.assign({}, rootProps, {
    className: classNameComponents.Root
  }), showBar && React.createElement(DatePickerActionBarActions, {
    className: classNameComponents.Actions
  }, showClearSelectionButton && React.createElement(Button, Object.assign({
    className: classNameComponents.ActionBarButton,
    tertiary: true,
    danger: true,
    paddingX: 1
  }, getClearSelectionButtonProps()), "Clear"), showTodayButtonRegular && React.createElement(Button, Object.assign({
    className: classNameComponents.ActionBarButton,
    tertiary: true,
    paddingX: 1
  }, getTodayButtonProps()), "Today")), showApplyButton && React.createElement(Button, Object.assign({}, getApplyButtonProps(), {
    className: classNameComponents.ActionBarButtonApply,
    primary: true
  }), "Apply"), showTodayButtonWide && React.createElement(Button, Object.assign({
    className: classNameComponents.ActionBarButton,
    secondary: true,
    wide: true
  }, getTodayButtonProps()), "Today"));
}));
DatePickerActionBar.displayName = DATE_PICKER_ACTION_BAR_CLASS_PREFIX;